<template>
  <div
    class="tags-atom"
    :style="styleObject"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TagAtom',
  props: {
    bgColor: {
      type: String,
      default: '--color-ui-element-blue-2'
    },
    textColor: {
      type: String,
      default: '--color-background-white'
    }
  },
  computed: {
    styleObject () {
      return {
        color: this.textColor.includes('#') ? this.textColor : `var(${this.textColor})`,
        backgroundColor: this.bgColor.includes('#') ? this.bgColor : `var(${this.bgColor})`
      }
    }
  }
}
</script>

<style scoped>
.tags-atom {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 17.5px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
}
</style>
